export enum FieldTypesEnum {
    INPUT_TEXT = 'INPUT_TEXT',
    INPUT_NUMBER = 'INPUT_NUMBER',
    CHECKBOX = 'CHECKBOX',
    RADIOBUTTONGROUP = 'RADIOBUTTONGROUP',
    SELECT = 'SELECT',
    MULTISELECT = 'MULTISELECT',
}